import React from 'react';
import Link from '@mui/material/Link';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { Text } from 'v3/components';
import { CardStyled, CloseButtonStyled, OpenInNewIconStyled, TextView } from './styles';

function MapDetailCard(props) {
  const openInNewTab = (url) => {
    window.open(url, '_blank', 'noreferrer');
  };

  const formatDate = (date) => {
    const m = moment(date);
    return m.isValid() ? m.format('DD/MM/YYYY - HH:mm:ss') : 'Não informado';
  };
  const rawPhone = props?.load?.phone || '';
  const onlyDigits = rawPhone.replace(/\D/g, '');
  const phoneWithCountry = onlyDigits.startsWith('55') ? onlyDigits : `55${onlyDigits}`;
  return (
    <CardStyled>
      <CloseButtonStyled type="button" onClick={props.onClose} aria-label="Fechar">
        ×
      </CloseButtonStyled>
      <Col md={12}>
        <Row md={12} lg={12} className="mt-2">
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Motorista:
              <br />
              {props?.load?.driveName || 'Não informado'}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Telefone:
              <br />
            </Text>
            <Link
              href={`https://api.whatsapp.com/send?phone=${phoneWithCountry}`}
              target="_blank"
              rel="noreferrer"
            >
              <TextView>{rawPhone || 'Não informado'}</TextView>
            </Link>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Cliente tomador:
              <br />
              {props?.load?.lastravelTakerName || 'Não informado'}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Endereço entrega da última viagem:
              <br />
              {props?.load?.lastTravelDeliveryAdress || 'Não informado'}
            </Text>
          </Col>
        </Row>
        <Row md={12} lg={12} className="mt-2">
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Tipo veículo de tração:
              <br />
              {props?.load?.tractionVehicleType || 'Não informado'}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Placa veículo de tração:
              <br />
              {props?.load?.tractionPlate || 'Não informado'}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Tipo dos implementos:
              <br />
              {props?.load?.vehicleType || 'Não informado'}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Placa implementos:
              <br />
              {props?.load?.wagonslate || 'Não informado'}
            </Text>
          </Col>
        </Row>
        <Row md={12} className="mt-2">
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Última viagem (Benner):
              <br />
              {props?.load?.lastExternalTravelNumber || 'Não informado'}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Última viagem (Cooperplace):
              <br />
              {props?.load?.lastTravelNumber || 'Não informado'}
            </Text>
            <TextView onClick={() => openInNewTab(`/viagens/${props?.load?.lastTravelNumber}`)}>
              Ver
            </TextView>
            <OpenInNewIconStyled />
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Data última posição:
              <br />
              {formatDate(props?.load?.lastDateInfo)}
            </Text>
          </Col>
          <Col md={3}>
            <Text fontSize={12} weight={500}>
              Localização última posição:
              <br />
              {props?.load?.lastRasterPosition || 'Não informado'}
            </Text>
          </Col>
        </Row>
      </Col>
    </CardStyled>
  );
}

export default MapDetailCard;
